import { createStore } from 'vuex';
import Cookies from 'js-cookie';
import {jwtDecode} from 'jwt-decode'; // Adjust the import statement
import tabletopEditor from './modules/tabletopEditor';
import tabletopPlayer from './modules/tabletopPlayer';

/*
 * Deliberately NOT `dx_backend_token`. The Google OAuth view sets a cookie of
 * that name server-side with httpOnly, and a browser rejects a document.cookie
 * write that would overwrite an httpOnly cookie of the same name and path — so
 * the JS write was silently dropped and the session vanished on the next full
 * page load. The two cookies now have separate names and separate owners.
 */
const COOKIE_NAME = 'dx_frontend_token';
const LEGACY_COOKIE_NAME = 'dx_backend_token';

const cookieOptions = (token) => {
  const options = {
    secure: window.location.protocol === 'https:',
    sameSite: 'Strict',
    path: '/',
  };
  if (token) {
    try {
      /* Align the cookie's lifetime with the token's own exp so a dead token
         is never resurrected from storage on the next page load. */
      const { exp } = jwtDecode(token);
      if (exp) options.expires = new Date(exp * 1000);
    } catch (error) {
      /* Undecodable token: fall back to a session cookie. */
    }
  }
  return options;
};

export default createStore({
  state: {
    user: null,
    token: Cookies.get(COOKIE_NAME) || null,
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setToken(state, token) {
      state.token = token;
      Cookies.set(COOKIE_NAME, token, cookieOptions(token));
    },
    clearAuth(state) {
      state.user = null;
      state.token = null;
      Cookies.remove(COOKIE_NAME, cookieOptions(null));
      /* Attribute-less cookies written by the previous release do not match
         the options above, so they need the bare removal too. */
      Cookies.remove(COOKIE_NAME);
      Cookies.remove(LEGACY_COOKIE_NAME);
    },
  },
  actions: {
    login({ commit }, { token }) {
      commit('setToken', token);
    },
    logout({ commit }) {
      commit('clearAuth');
    },
  },
  getters: {
    isAuthenticated: state => {
      if (state.token) {
        try {
          const decodedToken = jwtDecode(state.token); // Use jwt_decode
          const currentTime = Date.now() / 1000;
          return decodedToken.exp > currentTime;
        } catch (error) {
          return false;
        }
      }
      return false;
    },
    getAuthToken: state => state.token,
    isGameMaster: state => {
      if (state.token) {
        try {
          const decodedToken = jwtDecode(state.token);
          return decodedToken.is_game_master === true || decodedToken.is_staff === true || decodedToken.is_superuser === true;
        } catch (error) {
          return false;
        }
      }
      return false;
    },
  },
  modules: {
    tabletopEditor,
    tabletopPlayer
  }
});
